// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.iqPA5L {
  display: flex;
  flex-direction: column;
  flex: none;
  width: 240px;
  background: var(--surface-2);
  border: 1px solid var(--border);
  border-right: none;
  border-radius: var(--radius) 0 0 var(--radius);
  overflow: hidden;
  font-family: inherit;
}

.enw2J2 {
  flex: none;
  padding: 6px 8px;
  border-bottom: 1px solid var(--border);
  font-size: 12px;
  color: var(--text-muted);
  user-select: none;
  text-align: center;
}

.AGakMu {
  position: relative;
  flex: 1;
  min-height: 0;
  overflow: hidden;
}

.A2UZ16 {
  position: absolute;
  left: 0;
  top: 0;
  right: 0;
  will-change: transform;
}

.HgsXYq {
  display: flex;
  align-items: center;
  gap: 6px;
  padding: 0 6px;
  border-bottom: 1px solid var(--border);
  font-size: 12px;
  white-space: nowrap;
  overflow: hidden;
}

.dLQaVe {
  opacity: 0.4;
}

.DY811t ._zIAOm,
.DY811t .mWqJrD {
  color: var(--text-muted);
  text-decoration: line-through;
}

.QuCVgg {
  flex: none;
  width: 10px;
  height: 10px;
  border-radius: 50%;
}

._zIAOm {
  flex: 1;
  min-width: 0;
  overflow: hidden;
  text-overflow: ellipsis;
}

.mWqJrD {
  flex: none;
  color: var(--text-muted);
  font-family: ui-monospace, SFMono-Regular, Menlo, Consolas, monospace;
  font-size: 11px;
}

.NCMwTx {
  flex: none;
  width: 20px;
  height: 20px;
  padding: 0;
  border: 1px solid var(--border);
  border-radius: 4px;
  background: var(--surface);
  color: var(--text-muted);
  font-size: 11px;
  line-height: 1;
  cursor: pointer;
}

.NCMwTx:hover {
  border-color: var(--accent);
}

.FVbfLC {
  border-color: var(--accent);
  color: var(--accent);
  background: color-mix(in srgb, var(--accent) 18%, var(--surface));
}

.Q5qvXW {
  flex: none;
  font-size: 12px;
}

.Det5ol {
  flex: none;
  max-width: 76px;
  height: 20px;
  padding: 0 2px;
  font-size: 11px;
  color: var(--text);
  background: var(--surface);
  border: 1px solid var(--border);
  border-radius: 4px;
}
`, "",{"version":3,"sources":["webpack://./app/src/components/TrackList.module.css"],"names":[],"mappings":"AAAA;EACE,aAAa;EACb,sBAAsB;EACtB,UAAU;EACV,YAAY;EACZ,4BAA4B;EAC5B,+BAA+B;EAC/B,kBAAkB;EAClB,8CAA8C;EAC9C,gBAAgB;EAChB,oBAAoB;AACtB;;AAEA;EACE,UAAU;EACV,gBAAgB;EAChB,sCAAsC;EACtC,eAAe;EACf,wBAAwB;EACxB,iBAAiB;EACjB,kBAAkB;AACpB;;AAEA;EACE,kBAAkB;EAClB,OAAO;EACP,aAAa;EACb,gBAAgB;AAClB;;AAEA;EACE,kBAAkB;EAClB,OAAO;EACP,MAAM;EACN,QAAQ;EACR,sBAAsB;AACxB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,cAAc;EACd,sCAAsC;EACtC,eAAe;EACf,mBAAmB;EACnB,gBAAgB;AAClB;;AAEA;EACE,YAAY;AACd;;AAEA;;EAEE,wBAAwB;EACxB,6BAA6B;AAC/B;;AAEA;EACE,UAAU;EACV,WAAW;EACX,YAAY;EACZ,kBAAkB;AACpB;;AAEA;EACE,OAAO;EACP,YAAY;EACZ,gBAAgB;EAChB,uBAAuB;AACzB;;AAEA;EACE,UAAU;EACV,wBAAwB;EACxB,qEAAqE;EACrE,eAAe;AACjB;;AAEA;EACE,UAAU;EACV,WAAW;EACX,YAAY;EACZ,UAAU;EACV,+BAA+B;EAC/B,kBAAkB;EAClB,0BAA0B;EAC1B,wBAAwB;EACxB,eAAe;EACf,cAAc;EACd,eAAe;AACjB;;AAEA;EACE,2BAA2B;AAC7B;;AAEA;EACE,2BAA2B;EAC3B,oBAAoB;EACpB,iEAAiE;AACnE;;AAEA;EACE,UAAU;EACV,eAAe;AACjB;;AAEA;EACE,UAAU;EACV,eAAe;EACf,YAAY;EACZ,cAAc;EACd,eAAe;EACf,kBAAkB;EAClB,0BAA0B;EAC1B,+BAA+B;EAC/B,kBAAkB;AACpB","sourcesContent":[".list {\n  display: flex;\n  flex-direction: column;\n  flex: none;\n  width: 240px;\n  background: var(--surface-2);\n  border: 1px solid var(--border);\n  border-right: none;\n  border-radius: var(--radius) 0 0 var(--radius);\n  overflow: hidden;\n  font-family: inherit;\n}\n\n.head {\n  flex: none;\n  padding: 6px 8px;\n  border-bottom: 1px solid var(--border);\n  font-size: 12px;\n  color: var(--text-muted);\n  user-select: none;\n  text-align: center;\n}\n\n.viewport {\n  position: relative;\n  flex: 1;\n  min-height: 0;\n  overflow: hidden;\n}\n\n.rows {\n  position: absolute;\n  left: 0;\n  top: 0;\n  right: 0;\n  will-change: transform;\n}\n\n.row {\n  display: flex;\n  align-items: center;\n  gap: 6px;\n  padding: 0 6px;\n  border-bottom: 1px solid var(--border);\n  font-size: 12px;\n  white-space: nowrap;\n  overflow: hidden;\n}\n\n.rowHidden {\n  opacity: 0.4;\n}\n\n.rowMuted .name,\n.rowMuted .count {\n  color: var(--text-muted);\n  text-decoration: line-through;\n}\n\n.dot {\n  flex: none;\n  width: 10px;\n  height: 10px;\n  border-radius: 50%;\n}\n\n.name {\n  flex: 1;\n  min-width: 0;\n  overflow: hidden;\n  text-overflow: ellipsis;\n}\n\n.count {\n  flex: none;\n  color: var(--text-muted);\n  font-family: ui-monospace, SFMono-Regular, Menlo, Consolas, monospace;\n  font-size: 11px;\n}\n\n.btn {\n  flex: none;\n  width: 20px;\n  height: 20px;\n  padding: 0;\n  border: 1px solid var(--border);\n  border-radius: 4px;\n  background: var(--surface);\n  color: var(--text-muted);\n  font-size: 11px;\n  line-height: 1;\n  cursor: pointer;\n}\n\n.btn:hover {\n  border-color: var(--accent);\n}\n\n.btnActive {\n  border-color: var(--accent);\n  color: var(--accent);\n  background: color-mix(in srgb, var(--accent) 18%, var(--surface));\n}\n\n.drumKit {\n  flex: none;\n  font-size: 12px;\n}\n\n.select {\n  flex: none;\n  max-width: 76px;\n  height: 20px;\n  padding: 0 2px;\n  font-size: 11px;\n  color: var(--text);\n  background: var(--surface);\n  border: 1px solid var(--border);\n  border-radius: 4px;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"list": `iqPA5L`,
	"head": `enw2J2`,
	"viewport": `AGakMu`,
	"rows": `A2UZ16`,
	"row": `HgsXYq`,
	"rowHidden": `dLQaVe`,
	"rowMuted": `DY811t`,
	"name": `_zIAOm`,
	"count": `mWqJrD`,
	"dot": `QuCVgg`,
	"btn": `NCMwTx`,
	"btnActive": `FVbfLC`,
	"drumKit": `Q5qvXW`,
	"select": `Det5ol`
};
export default ___CSS_LOADER_EXPORT___;
